import React from 'react';
import TextField from '@mui/material/TextField';

const AlertTextField = ({ placeholder, value, onChange, error, helperText, type = 'text' }) => (
    <TextField
        placeholder={placeholder}
        variant="standard"
        type={type}
        value={value}
        onChange={onChange}
        required
        error={error}
        helperText={error ? helperText : ""}
        sx={{
            '& ::placeholder': { fontSize: '12px' },
            '& .MuiInputBase-input': {
                fontSize: '12px',
            },
            width: '55%',
        }}
    />
);

export default AlertTextField;
